export class InActivityTimerConst {
  static readonly MINUTES_IDLE_ALLOWED = 27;

  static readonly LOGOUT_WARNING_DURATION_IN_MINS = 3;
}
